"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { RatingWithProfileInfoAndLevel } from "@/entities/IProfile";
import { SortDirection } from "@/entities/ISort";
import UserCICStatus from "@/components/user/utils/user-cic-status/UserCICStatus";
import UserCICTypeIconWrapper from "@/components/user/utils/user-cic-type/UserCICTypeIconWrapper";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { Page } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import { ProfileRatersParamsOrderBy, RateMatter } from "@/types/enums";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import TopRaterAvatars from "../../rep/header/TopRaterAvatars";
const TOP_RATERS_COUNT = 5;
export default function UserPageIdentityHeaderCIC(t0) {
  const $ = _c(39);
  const {
    profile
  } = t0;
  const [cicRating, setCicRating] = useState(profile.cic);
  let t1;
  let t2;
  if ($[0] !== profile.handle) {
    t1 = [QueryKey.PROFILE_RATERS, {
      handleOrWallet: profile.handle,
      matter: RateMatter.NIC,
      page: 1,
      pageSize: 1,
      order: SortDirection.DESC,
      orderBy: ProfileRatersParamsOrderBy.RATING,
      given: false
    }];
    t2 = async () => await commonApiFetch({
      endpoint: `profiles/${profile.handle}/cic/ratings/by-rater`,
      params: {
        page: "1",
        page_size: "1",
        order: SortDirection.DESC.toLowerCase(),
        order_by: ProfileRatersParamsOrderBy.RATING.toLowerCase(),
        given: "false"
      }
    });
    $[0] = profile.handle;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = !!profile.handle;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: ratings
  } = useQuery(t4);
  let t5;
  if ($[7] !== profile.cic) {
    t5 = () => {
      setCicRating(profile.cic);
    };
    $[7] = profile.cic;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== profile) {
    t6 = [profile];
    $[9] = profile;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-mb-2 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">NIC</div>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== cicRating) {
    t8 = formatNumberWithCommas(cicRating);
    $[12] = cicRating;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <div className="tw-text-3xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-white">{t8}</div>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== profile) {
    t10 = <span className="-tw-mt-0.5 tw-h-4 tw-w-4 tw-flex-shrink-0"><UserCICTypeIconWrapper profile={profile} /></span>;
    $[16] = profile;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== cicRating) {
    t11 = <UserCICStatus cic={cicRating} />;
    $[18] = cicRating;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <div className="tw-mt-2 tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-semibold tw-uppercase">{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t9) {
    t13 = <div className="tw-flex tw-flex-col tw-items-start">{t9}{t12}</div>;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = profile.handle ?? "";
  let t15;
  if ($[26] !== t14) {
    t15 = <TopRaterAvatars handleOrWallet={t14} matter={RateMatter.NIC} count={TOP_RATERS_COUNT} size="md" />;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = ratings?.count ?? 0;
  let t17;
  if ($[28] !== t16) {
    t17 = formatNumberWithCommas(t16);
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const t18 = (ratings?.count ?? 0) === 1 ? "rater" : "raters";
  let t19;
  if ($[30] !== t17 || $[31] !== t18) {
    t19 = <span className="tw-text-sm tw-font-normal tw-text-iron-400">{t17}{" "}{t18}</span>;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t15 || $[34] !== t19) {
    t20 = <div className="tw-flex tw-shrink-0 tw-flex-col tw-items-end tw-gap-2.5">{t15}{t19}</div>;
    $[33] = t15;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t13 || $[37] !== t20) {
    t21 = <div className="tw-mb-8">{t7}<div className="tw-mt-1 tw-flex tw-items-start tw-justify-between tw-gap-6">{t13}{t20}</div></div>;
    $[36] = t13;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  return t21;
}